import { getProvider } from '../../../../apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const initialState = {
  status: 'Default'
}

const PassivateSimCardModule = {
  namespaced: true,
  state: initialState,
  getters: {
    currentStatus: state => state.status
  },
  actions: {
    async requestPassivateSimCard ({ commit, state, getters, rootGetters }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation passivateSimCard {
          passivateSimCard {
            success
            status
          }
        }`
      }).then((response) => {
        commit('Transaction/removeTransactionId', 'passivateSimCard', { root: true })
        if ((response.data.passivateSimCard.success === true) && (response.data.passivateSimCard.status !== 'running')) {
          state.status = 'Running'
          commit('addMessage', {
            type: 'success',
            message: 'Die Sperrung Ihrer SIM-Karte wurde erfolgreich erfasst und erfolgt in der Regel innerhalb der nächsten 30 Minuten.\n' +
              'Mit Sperrung der SIM-Karte wird aus Sicherheitsgründen auch Ihr online Zugang gesperrt. Eine Entsperrung kann nur durch Sie persönlich über die LIDL Connect Kundenbetreuung erfolgen.'
          }, { root: true })
        } else if ((response.data.passivateSimCard.success === false) && (response.data.passivateSimCard.status === 'running')) {
          state.status = 'Running'
          commit('addMessage', {
            type: 'danger',
            message: 'Die Sperrung Ihrer SIM-Karte wird derzeit verarbeitet.'
          }, { root: true })
        } else {
          state.status = 'Passivated'
          commit('addMessage', {
            type: 'danger',
            message: 'SIM-Karte ist bereits gesperrt.'
          }, { root: true })
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {}
}

export {
  PassivateSimCardModule
}
